import CreditSVG from '../Icons/CreditSVG';
import DebitSVG from '../Icons/DebitSVG';

const CreditDebitIcon = ({ isDebited }: { isDebited: any }) => {
  return <>{isDebited ? <CreditSVG /> : <DebitSVG />}</>;
};

export default CreditDebitIcon;
